// extracted by mini-css-extract-plugin
export default {"languageDot":"LanguageDot-module__languageDot--O6n2z","languageDotCompact":"LanguageDot-module__languageDotCompact--V51gt"};